import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { BluetoothProvider } from "@/contexts/BluetoothContext";

// Safari iOS zoome sur tout champ dont le texte fait moins de 16px et ne
// dézoome pas ensuite. maximum-scale=1 supprime ce zoom automatique sans
// bloquer le zoom au pincement sur iOS ; on ne l'applique pas ailleurs, où il
// empêcherait de zoomer.
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
if (isIOS) {
  const viewport = document.querySelector('meta[name="viewport"]');
  viewport?.setAttribute("content", `${viewport.getAttribute("content")}, maximum-scale=1`);
}

createRoot(document.getElementById("root")!).render(
  <BluetoothProvider>
    <App />
  </BluetoothProvider>
);
